import React from "react";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import YellowDivider from "../../dividers/YellowDivider";
import "../../../stylesheet/components/about/zepartners/ZePartners.scss";
import ZePartnerItem from "./ZePartnerItem";

// ZePartner Images
import PheonixImg from "../../../assets/img/zepartners/pheonix.png";
import YBCImg from "../../../assets/img/zepartners/ybc.png";
import ScrateIoImg from "../../../assets/img/zepartners/scrateio.png";
import AlSahreaImg from "../../../assets/img/zepartners/alsahrea.png";
import BMGImg from "../../../assets/img/zepartners/blockchain-marketing-group.png";
import SatoshiatImg from "../../../assets/img/zepartners/satoshiat.png";
import AuditorImg from "../../../assets/img/zepartners/blockchain-auditor.png";
import HorizonImg from "../../../assets/img/zepartners/horizon.png";

const ZE_PARTNER_ITEMS = [
  {
    name: "Phoenix",
    img: PheonixImg,
    link: "https://phoenix.io/",
  },
  {
    name: "Yale Blockchain Club",
    img: YBCImg,
    link: "https://www.yaleblockchainclub.com/",
  },
  {
    name: "Scrate.io",
    img: ScrateIoImg,
    link: "https://scrate.io",
  },
  {
    name: "Ashar3",
    img: AlSahreaImg,
    link: "http://ashar3.com/ar/",
  },
  {
    name: "Blockchain Marketing Group",
    img: BMGImg,
    link: "https://blockchainmarketinggroup.io/",
  },
  {
    name: "Satoshiat",
    img: SatoshiatImg,
    link: "https://www.satoshiat.com/",
  },
  {
    name: "The Blockchain Auditor",
    img: AuditorImg,
    link: "https://theblockchainauditor.com/",
  },
  {
    name: "Crypto Horizon",
    img: HorizonImg,
    link: "https://crypto-horizon.com/",
  },
];

const ZePartners: React.FC = () => {
  const { t, ready } = useTranslation();

  const getBody = () => {
    if (ready) {
      return t("about-zefi.ze-partners.body");
    }
    return (
      <div>
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
      </div>
    );
  };

  return (
    <div className="container my-4">
      <div className="info-section__info-wrapper d-flex h-100 flex-column">
        <div className="col-12 col-lg-6 px-0">
          <div className="mb-3 mb-lg-4">
            <h2>
              {ready ? (
                t("about-zefi.ze-partners.title")
              ) : (
                <Skeleton width={350} />
              )}
            </h2>
            <YellowDivider heading="h2" />
          </div>
          <div className="mx-xl-5 mt-3">
            <div className="mx-2 p3">{getBody()}</div>
          </div>
        </div>
        <div className="zefi-partner-container mt-4">
          {ZE_PARTNER_ITEMS.map((item) => (
            <ZePartnerItem
              key={`zepartner-item-${item.name
                .replaceAll(" ", "-")
                .toLowerCase()}`}
              name={item.name}
              img={item.img}
              link={item.link}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ZePartners;
